import { getAccountByTenantId } from "../../utils/accountUtils";

const fetchAllItems = async (instance, account, url) => {
  let allItems = [];
  let nextLink = url;

  while (nextLink) {
    const response = await instance.acquireTokenSilent({
      scopes: ["https://graph.microsoft.com/.default"],
      account: account,
    });

    const result = await fetch(nextLink, {
      headers: {
        Authorization: `Bearer ${response.accessToken}`,
      },
    });

    const data = await result.json();
    allItems = [...allItems, ...data.value];

    nextLink = data["@odata.nextLink"];
  }

  return allItems;
};

export const fetchAuthorDropdownOptions = async (instance, accounts, tenantId) => {
  try {
    const account = getAccountByTenantId(accounts, tenantId);
    const baseUrl = `${process.env.REACT_APP_GRAPH_API_URL}/sites/${process.env.REACT_APP_SP_SITE_ID}/lists/${process.env.REACT_APP_DROPDOWN_LIST_ID}/items?$expand=fields`;
    
    const items = await fetchAllItems(instance, account, baseUrl);
    
    // Process items to create the author dropdown options
    const authorOptions = items.reduce((acc, item) => {
      const { Title, field_1, field_2 } = item.fields;
      
      // Only process items where Title is "title"
      if (Title.toLowerCase() === "title") {
        if (field_1 && !acc.includes(field_1)) {
          acc.push({
            value: field_1,
            label: field_1,
            description: field_2 || ""
          });
        }
      }
      
      return acc;
    }, []);

    return authorOptions;
  } catch (error) {
    console.error("Error fetching author dropdown options:", error);
    throw error;
  }
};

export const addNewDropdownItem = async (instance, accounts, tenantId, payload) => {
  try {
    const account = getAccountByTenantId(accounts, tenantId);
    const response = await instance.acquireTokenSilent({
      scopes: ["https://graph.microsoft.com/.default"],
      account: account,
    });

    const url = `${process.env.REACT_APP_GRAPH_API_URL}/sites/${process.env.REACT_APP_SP_SITE_ID}/lists/${process.env.REACT_APP_DROPDOWN_LIST_ID}/items`;
    
    const result = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${response.accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        fields: {
          Title: payload.Title,
          field_1: payload.field_1,
          field_2: payload.field_2
        }
      })
    });

    if (!result.ok) {
      throw new Error(`Failed to add new dropdown item: ${result.statusText}`);
    }

    return await result.json();
  } catch (error) {
    console.error("Error adding new dropdown item:", error);
    throw error;
  }
}; 